// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2_UJG","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__25qaB"};